import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import { LanguageCodes } from './constants';
import en from './translations/en.json';
import fr from './translations/fr.json';

const supportedLanguages = [LanguageCodes.EN, LanguageCodes.FR];

const configureI18n = () => {
  i18next
    .use(I18nextBrowserLanguageDetector)
    .use(initReactI18next)
    .init({
      supportedLngs: supportedLanguages,
      fallbackLng: LanguageCodes.EN,
      defaultLanguage: LanguageCodes.EN,
      resources: {
        en: {
          translation: en,
        },
        fr: {
          translation: fr,
        },
      },
      react: {
        useSuspense: false,
      },
      interpolation: {
        skipOnVariables: false,
      },
      detection: {
        order: ['querystring'],
        lookupQuerystring: 'lang',
      },
    });
};

export default configureI18n;
